import { UserOnboardingSchema } from "@redotech/redo-model/onboarding/user-onboarding";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getUserOnboarding = {
  name: "getUserOnboarding" as const,
  input: z.null(),
  output: zExt.filterToValidArray(UserOnboardingSchema),
};
